<template>
    <svg viewBox="0 0 3 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.4985 25.5C1.2915 25.5 1.12351 25.668 1.12501 25.875C1.12501 26.082 1.29301 26.25 1.50001 26.25C1.70701 26.25 1.87501 26.082 1.87501 25.875C1.87501 25.668 1.707 25.5 1.4985 25.5"
            stroke="currentColor"
            stroke-width="2.25"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.5 19.5V1.5"
            stroke="currentColor"
            stroke-width="2.25"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
